import { useEffect, useState } from "react"
import { useCountryStore } from "@/Store/CountryStore"
import axios from "axios"

export const useCountryLocation = () => {
  const countries = useCountryStore(state => state.countries)
  const setIpCountry = useCountryStore(state => state.setIpCountry)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!countries.length) return

    const cached = localStorage.getItem("ip_country")
    if (cached && cached.length === 3) {
      setIpCountry(cached)
      return
    }

    const fetchCountry = async () => {
      setIsLoading(true)
      try {
        const res = await axios.get(
          `https://iplocate.io/api/lookup`
        )
        const location =  res.data

        const found = countries.find(
          c =>
            c.alpha3 === location.country ||
            c.name.toLowerCase().includes(location.country?.toLowerCase())
        )

        const code = found?.alpha3 || "USA"
        localStorage.setItem("ip_country", code)
        setIpCountry(code)
      } catch {
        try {
          const res = await fetch("https://geolocation-db.com/json/")
          const data = await res.json()

          const found = countries.find(c =>
            c.name.toLowerCase().includes(data?.country_name?.toLowerCase())
          )

          const code = found?.alpha3 || "USA"
          localStorage.setItem("ip_country", code)
          setIpCountry(code)
        } catch {
          localStorage.setItem("ip_country", "USA")
          setIpCountry("USA")
        }
      } finally {
        setIsLoading(false)
      }
    }

    fetchCountry()
  }, [countries])


  return { isLoading }
}